import { createRoot } from 'react-dom/client';

// Takes an element and replaces the contents with a React component. TODO: find
// out how to avoid the unnecessary surrounding div
//
// This is currently used in PersonalCalendarWidget to replace a "event dot"
// with our availability icon. There was no render hook in FullCalendar to
// change this.
export const replaceContent = (element, component) => {
  const tempDiv = document.createElement('div');

  // use new React 18 createRoot API
  const root = createRoot(tempDiv);
  root.render(component);
  element.innerHTML = '';
  element.appendChild(tempDiv);
};
